import { render } from "./addCoupon.vue?vue&type=template&id=00293f54&scoped=true"
import script from "./addCoupon.vue?vue&type=script&lang=js"
export * from "./addCoupon.vue?vue&type=script&lang=js"

import "./addCoupon.vue?vue&type=style&index=0&id=00293f54&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00293f54"]])

export default __exports__